import ActAditionalPreview from "../ActAditionalPreview";

function Watermark() {
  const rows = 12;
  const cols = 4;
  return (
    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, overflow: "hidden", pointerEvents: "none", zIndex: 10 }}>
      <div style={{ position: "absolute", top: "-20%", left: "-20%", right: "-20%", bottom: "-20%", display: "flex", flexDirection: "column", justifyContent: "space-around", transform: "rotate(-30deg)" }}>
        {Array.from({ length: rows }, (_, r) => (
          <div key={r} style={{ display: "flex", justifyContent: "space-around" }}>
            {Array.from({ length: cols }, (_, c) => (
              <span key={c} style={{ fontSize: "18px", fontWeight: 800, fontFamily: "'DM Sans', sans-serif", color: "rgba(196, 93, 62, 0.09)", letterSpacing: "0.15em", textTransform: "uppercase", whiteSpace: "nowrap", userSelect: "none" }}>
                PREVIEW – NU ESTE DOCUMENT FINAL
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

function PreviewWrapper({ children }) {
  return (
    <div style={{ position: "relative", userSelect: "none", WebkitUserSelect: "none" }} onCopy={(e) => e.preventDefault()}>
      {children}
      <Watermark />
    </div>
  );
}

export default function PreviewStep({ data, contractRef }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      <PreviewWrapper>
        <ActAditionalPreview ref={contractRef} data={data} />
      </PreviewWrapper>
    </div>
  );
}
